import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "#004A96"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.61811 10.8169C7.35149 11.061 6.92081 11.061 6.65419 10.8169L4.19995 8.56964C4.07194 8.45269 4 8.29391 4 8.12833C4 7.96274 4.07194 7.80396 4.19995 7.68701C4.46657 7.44288 4.89726 7.44288 5.16387 7.68701L7.13273 9.48983L11.8361 5.1831C12.1027 4.93897 12.5334 4.93897 12.8 5.1831C13.0667 5.42723 13.0667 5.8216 12.8 6.06573L7.61811 10.8169Z",
		fill: "white"
	})]
});
export default SvgRadioIcon;
